import api from "./api";

export async function getData() {
  const res = await api.get('/dashboard')
  return res.data
}
